import { Component } from '@angular/core';
import { IconComponent } from './icon.component';

@Component({
  selector: 'app-icon-valid',
  template: `<span class="icon icon-valid" [class.white]="color === 'white'"></span>`,
})
export class ValidIconComponent extends IconComponent { }
